import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "../components/Card.jsx";
import ConnectionForm from "../components/ConnectionForm.jsx";
import { connectionApi } from "../../api/connectionApi";
import { getApiError } from "../../api/client";
import "../styles/codebase.css";

export default function ConnectionAddPage() {
  const nav = useNavigate();
  const [err, setErr] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (payload) => {
    setErr("");
    setSaving(true);
    try {
      const res = await connectionApi.create(payload);
      nav(`/codebase/connections/${res.data.id}/edit`);
    } catch (e) {
      setErr(getApiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="cb-page">
      <div className="page-head">
        <div>
          <h2>Add Connection</h2>
          <div className="muted">Secrets are stored encrypted in Codebase DB</div>
        </div>
      </div>

      {err && <div className="error">{err}</div>}

      <Card title="Connection details">
        <ConnectionForm onSubmit={submit} submitting={saving} submitLabel="Create" />
      </Card>
    </div>
  );
}
